
export const formData = (form) => {
    let formdata = window.window.$(form).serializeArray();
    let data = {};
    window.$(formdata).each(function(index, obj){
        data[obj.name] = obj.value;
    });
    return data;
}

export const clearFormInputs = (form) => {
    let formEl = window.$(form);
    formEl.closest('.modal').modal('hide');
    formEl.find('input').val('');
}
